
@let client = session.subjectData;
<div>
  <button
    pButton
    type="button"
    [outlined]="true"
    class="client-info-button w-full text-left flex items-stretch justify-between pr-0 rounded-lg overflow-hidden focus-visible:ring-2 focus-visible:ring-[var(--p-primary-color)]"
    [ngClass]="{
      'client-selected': selected,
      'client-highlighted': highlight,
      'client-archived': archived
    }"
    (click)="selectClient()"
  >
    <div
      class="text-left font-normal text-[inherit] text-base leading-normal w-full"
    >
      <div class="w-full flex justify-between">
        <div class="flex items-center gap-3 overflow-hidden">
          <p-avatar
            [label]="initials"
            shape="circle"
            [styleClass]="
              'bg-primary text-white font-medium' +
              (selected ? ' avatar-selected' : '')
            "
            [style]="{ flex: '0 0 auto', width: '2.5rem', height: '2.5rem' }"
            [pTooltip]="collapsed ?  avatarTooltip : undefined"
            tooltipPosition="right"
          ></p-avatar>
          <ng-template #avatarTooltip>
              {{ client.firstName | capitalizeFirst  }} {{ client.lastName | capitalizeFirst  }}<br>
              {{ client.company | capitalizeFirst }}
          </ng-template>
        @if(!collapsed) {
          <div class="flex flex-col min-w-0 overflow-hidden">
            <div class="client-info-wrapper">
              <div class="client-name truncate">
                {{ client.firstName }} {{ client.lastName }}
              </div>
              <div class="client-company truncate">
                Company: {{ client.company | capitalizeFirst }}
              </div>
              @if(showGuid) {
                <div class="client-guid truncate">GUID: {{ client.guid }}</div>
              }
            </div>
          </div>
        }
        </div>

        <div class="text-xs text-gray-400 whitespace-nowrap ml-2">
          @if (showArchiveButton && !collapsed) {
            <button
              type="button"
              pButton
              icon="pi pi-times-circle"
              class="delete-button p-button-text p-button-sm p-button-danger"
              (click)="handleArchiveSession($event)"
              pTooltip="Archive conversation"
              tooltipPosition="bottom"
            ></button>
          }
          @if (archived && !collapsed) {
            <button
              type="button"
              pButton
              icon="{{ _activeSession() ? 'pi pi-envelope' : 'pi pi-plus-circle' }}"
              class="handle-archived-button p-button-text p-button-sm"
              (click)="handleActivateOrCreateSession($event)"
              [pTooltip]="_activeSession() ? 'Go to active conversation' : 'Start new conversation'"
              tooltipPosition="bottom"
            ></button>
          }
        </div>
      </div>
    </div>
  </button>
</div>


<lib-feedback-dialog
  *ngIf="showFeedbackDialog"
  [visible]="true"
  [feedbackProps]="archivedChatFeedback"
  (closeDialog)="closeArchiveFeedback()"
  (canceled)="cancelArchiveFeedback()"
></lib-feedback-dialog>
